import urlServiceProvider from "services/urlServiceProvider";

const { fetchWrapper } = require("helpers/fetchWrapper");

const baseUrl = urlServiceProvider.baseUrl;
const maintenancePhotoUrl = "/client/api/v1/maintenancephoto";

const getMaintenancePhoto = async (id) => {
  const url = `${baseUrl}${maintenancePhotoUrl}/${id}`;
  const response = await fetchWrapper().get(url);
  const result = await response.json();

  if (!response.ok) {
    throw response;
  }

  return result;
};

const addMaintenancePhoto = async (body) => {
  const url = `${baseUrl}${maintenancePhotoUrl}/create`;
  const response = await fetchWrapper().post(url, body);
  const result = await response.json();

  if (!response.ok) {
    throw response;
  }

  return result;
};

/**
 * Returns the list of maintenancePhotos
 *
 * @param {*} body The body of the request. Can contain 'query', 'options' and 'isCountOnly'
 * @returns {*} response with the list of maintenancePhotos
 */
const findAllMaintenancePhoto = async (body) => {
  const options = {
    page: 1,
    paginate: 1000,
  };
  const url = `${baseUrl}${maintenancePhotoUrl}/list`;
  const response = await fetchWrapper().post(url, { options, ...body });
  const result = await response.json();

  if (!response.ok) {
    throw response;
  }

  return result.data;
};

const getCountMaintenancePhoto = async (body) => {
  const options = {
    page: 1,
    paginate: 1000,
  };
  const url = `${baseUrl}${maintenancePhotoUrl}/count`;
  const response = await fetchWrapper().post(url, { options, ...body });
  const result = await response.json();

  if (!response.ok) {
    throw response;
  }

  return result.data;
};

const softDeleteMaintenancePhoto = async (id) => {
  const url = `${baseUrl}${maintenancePhotoUrl}/partial-update/${id}`;
  const response = await fetchWrapper().put(url, { isDeleted: true });
  const result = await response.json();

  if (!response.ok) {
    throw response;
  }

  return result;
};

const partialUpdateMaintenancePhoto = async (id, body) => {
  const url = `${baseUrl}${maintenancePhotoUrl}/partial-update/${id}`;
  const response = await fetchWrapper().put(url, body);
  const result = await response.json();

  if (!response.ok) {
    throw response;
  }

  return result;
};

const updateMaintenancePhoto = async (id, body) => {
  const url = `${baseUrl}${maintenancePhotoUrl}/update/${id}`;
  const response = await fetchWrapper().put(url, body);
  const result = await response.json();

  if (!response.ok) {
    throw response;
  }

  return result;
};

const maintenancePhotoService = {
  getMaintenancePhoto,
  addMaintenancePhoto,
  findAllMaintenancePhoto,
  getCountMaintenancePhoto,
  softDeleteMaintenancePhoto,
  partialUpdateMaintenancePhoto,
  updateMaintenancePhoto,
};

export default maintenancePhotoService;
